<div class="overflow-hidden bg-white shadow-sm sm:rounded-lg h-full" id="panel-visuals">
  <div class="w-full flex flex-col flex-row bg-white">
    <div class="w-1/8 p-2 bg-white">&nbsp;</div>

    <div class="w-1/2 p-2 bg-white">
      <div class="png-stack">
        <img class="layer-frame" src="images/panel_resources/frames/{{ selectedHeight() }}.png"/>
        @if (t0Dir()) {
          <img class="layer-t0" src="images/panel_resources/{{ t0Dir() }}/{{ t0Mat().color }}.png" />
        }
        @if (t1Dir()) {
          <img class="layer-t1" src="images/panel_resources/{{ t1Dir() }}/{{ t1Mat().color }}.png" />
        }
        @if (t2Dir()) {
          <img class="layer-t2" src="images/panel_resources/{{ t2Dir() }}/{{ t2Mat().color }}.png" />
        }
        @if (t3Dir()) {
          <img class="layer-t3" src="images/panel_resources/{{ t3Dir() }}/{{ t3Mat().color }}.png" />
        }
        <img class="layer-style" src="images/panel_resources/style_labels/S{{selectedPanelStyle()}}.png" />
      </div>
    </div>

    <!-- Right (25%) -->
    <div class="w-1/4 p-2 bg-white">
      <img src="images/worksurfaces/{{worksurface().code}}.png" />
    </div>

  </div>

  <div class="w-full flex flex-col flex-row bg-white">
    <div class="w-1/8 p-2 bg-white"> </div>
    <div class="w-1/2 p-2 bg-white">
      <p class="text-center text-2xl font-bold">Panel Selections:</p>
      <p class="text-center text-xl"><span class="font-bold">Panel Style: </span>{{selectedPanelStyle()}}</p>
      @for (s of selections(); track s.zone; let i = $index) {
        <p class="text-center text-xl">
          <span class="font-bold">{{ s.zone }}: </span>
          @if (s.type && s.color) {
            {{ s.type | titlecase }} –
            {{ materialService.getColorLabel(s.type, s.color) }}
          } @else if (s.type) {
            {{ s.type | titlecase }} (no color selected)
          } @else {
            Not selected
          }
        </p>
      }
    </div>
    <div class="w-1/4 p-2 bg-white">
      <p class="text-center text-2xl font-bold">Worksuface Selection:</p>
      <p class="text-center text-xl">{{selectedWorksurface().name}} ({{selectedWorksurface().code}})</p>
    </div>
  </div>
</div>
